<template>
  <div class="home-faq-refund-container">
    <div class="faq-refund-grid">
      <section class="faq-section">
        <h2 class="section-title">자주 묻는 질문</h2>

        <ul class="faq-list">
          <li class="faq-item" v-for="(item, idx) in faqList" :key="idx">
            <span class="faq-check" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </span>
            <span class="faq-text">{{ item }}</span>
          </li>
        </ul>
      </section>

      <section class="refund-section">
        <h2 class="section-title">환불 정책</h2>

        <p class="refund-desc">
          설문 검수 전이라면 주문 금액 전액을 환불해드려요. 응답 수집이 시작된 뒤에는 부족분만 부분 환불해드려요.
        </p>

        <div class="refund-formula">
          <span class="refund-formula-term">주문 금액</span>
          <span class="refund-formula-op">×</span>
          <span class="refund-formula-term">부족 응답 수</span>
          <span class="refund-formula-op">÷</span>
          <span class="refund-formula-term">목표 응답 수</span>
          <span class="refund-formula-op">=</span>
          <span class="refund-formula-result">환불 금액</span>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeFaqRefund',

  data() {
    return {
      faqList: [
        '카드 결제가 필요하다면 채널톡으로 문의해주세요',
        '해외 대학(원)생도 할인 혜택을 받을 수 있어요',
        '설문 진행 중에도 응답 인원 추가가 가능해요',
        '응답 수가 부족한 경우, 추가 응답 수집 또는 부분 환불로 진행해드려요',
        '링크 오류가 걱정된다면 ABC 테스트도 가능해요'
      ]
    }
  }
}
</script>

<style scoped>
.home-faq-refund-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
}

.faq-refund-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
}

.section-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.faq-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.faq-item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-4);
  text-align: left;
}

.faq-check {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  color: var(--green-500);
}

.faq-check svg {
  width: 100%;
  height: 100%;
}

.faq-text {
  font-size: 15px;
  color: var(--ink-800);
  line-height: 1.6;
}

.refund-desc {
  margin: 0 0 var(--space-4) 0;
  font-size: 14px;
  color: var(--text-muted);
  line-height: 1.7;
  text-align: left;
}

.refund-formula {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-6);
  background-color: var(--bg-sunken);
  border-radius: var(--radius-lg);
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-body);
}

.refund-formula-op {
  color: var(--text-muted);
}

.refund-formula-result {
  color: var(--green-500);
  font-weight: var(--font-weight-semibold);
}

@media (max-width: 560px) {
  .faq-refund-grid {
    grid-template-columns: 1fr;
    gap: var(--space-8);
  }

  .section-title {
    font-size: 24px;
  }

  .refund-formula {
    padding: var(--space-4);
  }
}
</style>
